define('Components/StatusComeInWidget/js/views/StatusComeInWidgetInstanceView',['jquery','WidgetInstanceView','template!Components/StatusComeInWidget/templates/default',

        'template!Components/StatusComeInWidget/templates/fidelity'
    ],
    function($,WidgetInstanceView,defaultTemplate, fidelityTemplate){
    return WidgetInstanceView.extend({
        name:'StatusComeInWidgetInstanceView',
        events: {

        },
        getTemplate:function(){

            switch(this.model.getTemplate()){
                case 'fidelity':return fidelityTemplate; break;
                case 'default': default: return defaultTemplate; break;
            }
        },

    })
});
